import underConstruction from "../Assets/Gifs/under-construction.gif";

const AnimationHelper = {
  underConstruction,
};

export default AnimationHelper;
